export const deprecatedRoutes = [
  {
    path: "/settle-in",
    redirect: "/org-settled",
  },
];
